<template>
  <div class="flex aspect-video items-center justify-center rounded-3xl bg-muted">
    <div class="px-4 text-center text-muted-foreground">
      Unsupported video source
    </div>
  </div>
</template>
